import React from 'react';
import styled from 'styled-components';

type Props = {
  src: string;
  height: number;
  alt?: string;
};

const Image = styled.img<Props>`
  height: ${p => p.height}px;
  object-fit: cover;
  width: 100%;
`;

function CardImage({ src, height, alt }: Props) {
  return <Image src={src} alt={alt} height={height} />;
}

export default CardImage;
